import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";
import { UserForInternalActivityPanel } from "../activity/UserForInternalActivityPanel";
import UserOptionsPanel from "../../components/UserOptionsPanel";
import { UserForInternalDetailSection } from "../UserForInternalDetailSection";
import ICalendarFeedsPanel from "UserAdmin/components/ICalendarFeedsPanel";
import OwnerPanel from "UserAdmin/components/OwnerPanel";
import { DeactivatedUserDetailSection } from "UserAdmin/components/DeactivatedUserDetailSection";

export const UserForInternalDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.InternalUserToClientDetailFrontModel>();
  const [userSmall, setUserSmall] = React.useState<server.dto.UserSmall>(viewModel.internalUserToClient.user);

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          {viewModel.internalUserToClient.lifeCycle === "active" ? <UserForInternalDetailSection
            clientConfig={viewModel.clientConfiguration}
            userToClient={viewModel.internalUserToClient}
            onNameChanged={(firstName, lastName) => {
              setUserSmall({
                ...userSmall,
                firstName,
                lastName,
                fullName: `${firstName} ${lastName}`
              });
            }}
          /> : <DeactivatedUserDetailSection
            userToClient={viewModel.internalUserToClient}
            title={RESX.UserType.InternalUser}
            environment="internal"
          />}
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <UserOptionsPanel
            optionsPanelData={viewModel.optionsPanel}
            listUrl={viewModel.listUrl}
            userToClient={viewModel.internalUserToClient}
            userSmall={userSmall}
          />
          <OwnerPanel
            userToClientId={viewModel.internalUserToClient.userToClientId}
            clientConfig={viewModel.clientConfiguration}
          />
          {viewModel.internalUserToClient.lifeCycle === "active" && <ICalendarFeedsPanel
            userToClient={viewModel.internalUserToClient}
          />}
          <UserForInternalActivityPanel
            userToClientId={viewModel.internalUserToClient.userToClientId}
            config={viewModel.activityPanelConfig}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>
}